import Alpine from 'alpinejs';
import { createKasirAppContent } from './kasirAppContent.js';

Alpine.data('kasirCreatorAppContent', () =>
  createKasirAppContent('/api/v1/kasir/engagement/creator-app-content')
);
